export default __webpack_public_path__ + "static/media/menu-icon.3e9bd20c.svg";